import React from 'react'
import { clamp } from 'lodash'
import { Arc, Circle, Group, Text, Label, Tag } from 'react-konva'
import { toScale } from '../../../lib/canvas-math.js'

/** 25 takım rengi — birbirinden rahat ayırt edilebilir hex kodları */
const TEAM_COLORS = [
    '#E63946', '#F4A261', '#2A9D8F', '#264653', '#E9C46A',
    '#9B5DE5', '#00BBF9', '#00F5D4', '#FEE440', '#F15BB5',
    '#06FFA5', '#9B2226', '#0A9396', '#94D2BD', '#CA6702',
    '#BB3E03', '#AE2012', '#005F73', '#0D1B2A', '#1B263B',
    '#415A77', '#778DA9', '#E0E1DD', '#4CC9F0', '#7209B7',
]

const getPlayerColor = ({ colors }, teamColor) => {
    if (teamColor) return teamColor
    const base = colors.dot.enemy
    return `${base}E0`
}

const getBaseStatusColor = ({ colors }, marks, player, teamColor) => {
    if (player.status === 'dead') return colors.dot.dead
    if (player.status !== 'dead' && player.health === 0) return colors.dot.knocked
    if (teamColor) return teamColor
    return colors.dot.base
}

const getStatusColor = (opts, marks, player, teamColor) => {
    const base = getBaseStatusColor(opts, marks, player, teamColor)
    if (teamColor && base === teamColor) return teamColor
    return `${base}B0`
}

const PlayerLabel = ({ visible, player, strokeColor }) => {
    if (!visible) return null

    return (
        <Label offsetY={-11}>
            <Tag
                fill="#000000A0"
                pointerDirection="up"
                pointerHeight={7}
                pointerWidth={11}
                stroke={strokeColor}
                strokeWidth={0.5}
                cornerRadius={4}
            />
            <Text
                fill={strokeColor}
                lineHeight={1}
                padding={5}
                text={player.name}
                fontSize={10}
                align="center"
            />
        </Label>
    )
}

const getMovementStrokeColor = ({ colors }, player) => {
    // PCOB liveState meaning (from API LIST.md):
    // 0 = Normal, 1 = On Plane, 2 = On Parachute, 3 = On Vehicle, 4 = DBNO, 5 = Dead, 6 = Disconnected
    switch (player.liveState) {
    case 1: // Plane
        return '#FFFFFF'
    case 2: // Parachute
        return '#00FFFF'
    case 3: // Vehicle
        return '#FFA500'
    default:
        return '#000000'
    }
}

const PlayerDot = ({ options, player, pubgMapSize, mapSize, marks, mapScale, showName, teamIndex }) => {
    const diameter = marks.isPlayerHovered(player.name) ? 13 : 10
    const scaledDiameter = diameter * clamp(mapScale / 1.4, 1, 1.3)
    const health = player.health / 100
    const teamColor = teamIndex != null ? TEAM_COLORS[teamIndex % TEAM_COLORS.length] : null

    const mouseEvents = {
        onMouseOver(e) {
            marks.setHoveredPlayer(player.name)
        },

        onMouseOut() {
            marks.setHoveredPlayer(null)
        },

        onClick(e) {
            const toToggle = [player.name]

            if (e.evt.shiftKey) {
                toToggle.push(...player.teammates)
            }

            if (marks.isPlayerTracked(player.name)) {
                marks.setHoveredPlayer(null)
            }

            marks.toggleTrackedPlayer(...toToggle)
        },
    }

    const isVehicle = player.liveState === 3

    return (
        <Group
            x={toScale(pubgMapSize, mapSize, player.location.x)}
            y={toScale(pubgMapSize, mapSize, player.location.y)}
            scale={{ x: 1 / mapScale, y: 1 / mapScale }}
        >
            {isVehicle ? (
                <Group {...mouseEvents}>
                    {/* Direksiyon (yuvarlak) — araçta iken */}
                    <Circle
                        x={0}
                        y={0}
                        radius={scaledDiameter / 2}
                        stroke={teamColor || getMovementStrokeColor(options, player)}
                        strokeWidth={1.5}
                        fill={getStatusColor(options, marks, player, teamColor)}
                    />
                    <Circle
                        x={0}
                        y={0}
                        radius={scaledDiameter * 0.25}
                        fill={teamColor || '#333'}
                        stroke={getMovementStrokeColor(options, player)}
                        strokeWidth={0.5}
                    />
                </Group>
            ) : (
                <Group {...mouseEvents}>
                    <Circle
                        fill={getStatusColor(options, marks, player, teamColor)}
                        radius={(scaledDiameter / 2) + 0}
                        stroke={getMovementStrokeColor(options, player)}
                        strokeWidth={1}
                    />
                    <Arc
                        fill={getPlayerColor(options, teamColor)}
                        innerRadius={0}
                        outerRadius={scaledDiameter / 2}
                        angle={(360 * health)}
                    />
                </Group>
            )}
            <PlayerLabel
                player={player}
                visible={showName || marks.isPlayerHovered(player.name)}
                strokeColor={getPlayerColor(options, teamColor)}
            />
        </Group>
    )
}

export default PlayerDot



// WEBPACK FOOTER //
// ./src/components/MatchPlayer/Map/PlayerDot.js